// uploadFile uploads a browser File/Blob to appstatic.app.nz and returns its
// public URL. The same-origin relay in server/upload.go validates the sniffed
// file type and enforces the endpoint-specific size limit before writing to R2.

export interface UploadProgress {
  (fraction: number): void;
}

async function postRelay(file: File): Promise<string> {
  const form = new FormData();
  form.append('file', file);
  const res = await fetch('/api/upload', { method: 'POST', body: form, credentials: 'include' });
  const body = await res.json().catch(() => null);
  if (!res.ok || !body?.success) {
    throw new Error(body?.error || `upload failed (${res.status})`);
  }
  const url = body.url || body.publicUrl || body.public_url;
  if (!url) throw new Error('upload returned no URL');
  return url as string;
}

// uploadFile returns the public URL of the stored file. Throws on failure.
export async function uploadFile(file: File): Promise<string> {
  return postRelay(file);
}
